import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["articlesList", "sentinel", "loader", "endMessage"]
  static values = {
    url: String,
    page: { type: Number, default: 1 },
    maxPages: { type: Number, default: 10 },
    hasMore: Boolean
  }

  connect() {
    this.loading = false
    if (!this.hasMoreValue || !this.hasSentinelTarget) return

    this.observer = new IntersectionObserver(
      (entries) => { if (entries[0].isIntersecting) this.loadNextPage() },
      { rootMargin: "200px" }
    )
    this.observer.observe(this.sentinelTarget)
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  }

  async loadNextPage() {
    if (this.loading || !this.hasMoreValue || this.pageValue >= this.maxPagesValue) {
      this.stopObserving()
      return
    }

    this.loading = true
    this.loaderTarget.classList.remove("hidden")
    const nextPage = this.pageValue + 1

    try {
      const response = await fetch(`${this.urlValue}?page=${nextPage}`, {
        headers: { "X-Requested-With": "XMLHttpRequest" }
      })

      if (response.status === 204 || !response.ok) {
        this.hasMoreValue = false
        this.stopObserving()
        return
      }

      const html = await response.text()
      this.articlesListTarget.insertAdjacentHTML("beforeend", html)
      this.pageValue = nextPage

      const hasMore = response.headers.get("X-Has-More") === "true"
      this.hasMoreValue = hasMore

      if (!hasMore || nextPage >= this.maxPagesValue) {
        this.stopObserving()
      }
    } catch {
      this.hasMoreValue = false
      this.stopObserving()
    } finally {
      this.loading = false
      this.loaderTarget.classList.add("hidden")
    }
  }

  stopObserving() {
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
    if (this.hasSentinelTarget) this.sentinelTarget.classList.add("hidden")
    if (this.pageValue > 1 && this.hasEndMessageTarget) {
      this.endMessageTarget.classList.remove("hidden")
    }
  }
}
